package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.repository.WhiteboardRepository

/**
 * Use case for clearing all content from the whiteboard.
 * Broadcasts the clear action to all participants.
 */
class ClearWhiteboardUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Clears all content from the whiteboard.
     *
     * @param tableId The game table ID
     * @param whiteboardId The whiteboard ID
     * @param performedBy The user ID who cleared the whiteboard
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        tableId: String,
        whiteboardId: String,
        performedBy: String
    ): Result<Unit> {
        return whiteboardRepository.broadcastAction(
            tableId = tableId,
            whiteboardId = whiteboardId,
            action = WhiteboardAction.Clear,
            performedBy = performedBy
        )
    }
}
